import { __extends } from "tslib";
import BSSSwiperTabsComponent from './bss-swiper-tabs-component';
import logger from '@main/externals/bss-package-logger/js/logger';
/**
 * BSSSwiperTabsAnimations class
 */
var BSSSwiperTabsAnimations = /** @class */ (function (_super) {
    __extends(BSSSwiperTabsAnimations, _super);
    /**
     * BSSSwiperTabsAnimations constructor
     * @param {object} _entityTemplate simulator template
     * @param {string} containerSelector container selector of components
     * @param {object} config configuration object
     * @param {EventManager} eventManager instance of _EventManager
     * @param {Formatter} formatter instance of Formatter
     * @param {Resolution} resolution device Resolution
     * @param {Object} toolbox
     */
    function BSSSwiperTabsAnimations(_entityTemplate, containerSelector, config, eventManager, formatter, resolution, toolbox) {
        var _this = _super.call(this, _entityTemplate, containerSelector, config, eventManager, formatter, resolution, toolbox) || this;
        logger.info('SwiperTabsAnimations:  => constructor : componentId: ' +
            config.componentId +
            ' | Params: ', _entityTemplate, containerSelector, config, eventManager, formatter, resolution, logger, toolbox);
        _this._resizeTimeoutDestroyer = null;
        return _this;
    }
    /**
     * @desc catch and add all necessary element and resizeHandler
     * @listens {bss-start-resize-for-$ENTITY-INSTANCE-ID}
     * @listens {bss-stop-resize-for-$ENTITY-INSTANCE-ID}
     * @private
     */
    BSSSwiperTabsAnimations.prototype._initAnimation = function () {
        logger.info('SwiperTabsAnimations: ' +
            this._config.componentId +
            ' => function : _initAnimation');
        this.animateTriggers = this._toolbox
            .$('#' + this._config.componentId)
            .find('.bss-swiper-tabs-nav_trigger');
        this.triggersWrapper = this._entityTemplate.find('.bss-swiper-tabs-wrapper');
        this.animateTriggers
            .parent()
            .append('<span class="bss-swiper-tabs-active-trigger-indicator"></span>');
        this._activeTriggerIndicator = this._toolbox
            .$('#' + this._config.componentId)
            .find('.bss-swiper-tabs-active-trigger-indicator');
        this._isResizeEventOff = true;
        this._bindResize();
        this._eventManager.subscribe('bss-start-resize-for-' + this._config.entityInstanceId, this._bindResize.bind(this), this.subscriberPrefix + this._config.componentId);
        this._eventManager.subscribe('bss-stop-resize-for-' + this._config.entityInstanceId, this._unbindResize.bind(this), this.subscriberPrefix + this._config.componentId);
    };
    /**
     * @desc bind window scroll event
     * @private
     */
    BSSSwiperTabsAnimations.prototype._bindResize = function () {
        logger.info('SwiperTabsAnimations: ' +
            this._config.componentId +
            ' => function : _bindResize');
        if (this._isResizeEventOff) {
            _super.prototype._bindResize.call(this);
            this._window.on('resize.' + this._config.componentId, this._resizeHandler.bind(this));
            this._isResizeEventOff = false;
        }
    };
    /**
     * @desc unbind window scroll event
     * @private
     */
    BSSSwiperTabsAnimations.prototype._unbindResize = function () {
        logger.info('SwiperTabsAnimations: ' +
            this._config.componentId +
            ' => function : _unbindResize');
        _super.prototype._unbindResize.call(this);
        this._window.off('resize.' + this._config.componentId);
        this._isResizeEventOff = true;
    };
    /**
     * @desc fires resize handler with proper time offset
     * @private
     */
    BSSSwiperTabsAnimations.prototype._resizeHandler = function () {
        logger.info('SwiperTabsAnimations: ' +
            this._config.componentId +
            ' => function : _resizeHandler');
        if (this._resizeTimeoutDestroyer !== null) {
            clearTimeout(this._resizeTimeoutDestroyer);
        }
        // interval is needed because indicator calculates based on swiper triggers size and we must wait until triggers are visible
        // param for reinit swiper when swiper set bad calculated width
        this._reinitSwiperWidth = true;
        this._resizeTimeoutDestroyer = setTimeout(this._resizeHandlerCallback.bind(this), 300);
        this._tabsTriggers.slideTo(this._tabsContent.activeIndex, 0);
    };
    /**
     * @desc resize the active element indicator on resize event
     * @private
     */
    BSSSwiperTabsAnimations.prototype._resizeHandlerCallback = function () {
        logger.info('SwiperTabsAnimations: ' +
            this._config.componentId +
            ' => function : _resizeHandlerCallback');
        var activeSlide = this._toolbox.$(this._triggerSlides[this._tabsContent.activeIndex]);
        var height = activeSlide.outerHeight();
        var params = {
            height: height,
        };
        if (this._resolution.getCurrent() === 'xs') {
            params.x = '0';
            params.width = '100%';
            this._changeIconDropdownMenu(this._tabsContent);
        }
        else {
            //sometimes idangerous doesnt clean styles
            this._tabsTriggers.wrapperEl.style.width = 'auto';
            this._tabsContent.update();
            var dropDownContent = this._toolbox.$('#' + this._config.componentId + ' .bss-swiper-tabs-nav-wrapper');
            dropDownContent.css({ display: '' });
            this.animateTriggers.css({ transform: 'translateX(0%)' });
            dropDownContent.removeClass('is-moved');
            dropDownContent.removeClass('is-open');
            if (this._dropdownButtonTrigger.hasClass('is-active')) {
                this._dropdownButtonTrigger.removeClass('is-active');
            }
            // we add bg because it's impossible to catch the moment when swiper resize is ended, so indicator have problems with setting right params: height, width left top...
            this._toolbox
                .$(activeSlide)
                .addClass('bss-swiper-tabs-nav_trigger-indicator');
            var slidersWidth = 0;
            for (var i = 0, length_1 = this._tabsContent.slides.length; i < length_1; i += 1) {
                slidersWidth += this._toolbox.$(this._triggerSlides[i]).outerWidth();
            }
            params.x = slidersWidth + '';
            params.width = '0';
            params.rotationX = '0deg';
            params.transformPerspective = '0';
            if (this._reinitSwiperWidth && slidersWidth > dropDownContent.width()) {
                // create event to call window resize event
                var evt = window.document.createEvent('UIEvents');
                evt.initUIEvent('resize', true, false, window, 0);
                window.dispatchEvent(evt);
                this._reinitSwiperWidth = false;
                return;
            }
        }
        this._triggerSlides.removeClass('is-active');
        activeSlide.addClass('is-active');
        this._activeTriggerIndicator.css(params);
        this._resizeTimeoutDestroyer = null;
        this._setParentContainerMarginTop();
    };
    /**
     * @desc callback for mobile triggers show action
     * @param dropDownContent
     * @private
     */
    BSSSwiperTabsAnimations.prototype._showTriggersCallback = function (dropDownContent) {
        logger.info('SwiperTabsAnimations: ' +
            this._config.componentId +
            ' => function : _showTriggersCallback | Params', dropDownContent);
        _super.prototype._showTriggersCallback.call(this, dropDownContent);
        this._setActiveSlide(this._tabsContent, false, true);
    };
    /**
     * @desc callback for mobile triggers hide action
     * @param dropDownContent
     * @private
     * @override
     */
    BSSSwiperTabsAnimations.prototype._hideTriggersCallback = function (dropDownContent) {
        logger.info('SwiperTabsAnimations: ' +
            this._config.componentId +
            ' => function : _hideTriggersCallback | Params', dropDownContent);
        this._activeTriggerIndicator.height(0);
        var self = this;
        var afterClickActionDelay = this._config.afterClickActionDelay || 0;
        dropDownContent
            .delay(afterClickActionDelay)
            .slideUp(this._config.slideDuration, function () {
            if (!self._config.newDesign) {
                dropDownContent.css({ display: '' });
                self._activeTriggerIndicator.css({ transform: 'translateX(0%)' });
                self.animateTriggers.css({ transform: 'translateX(0%)' });
                dropDownContent.removeClass('is-moved');
            }
        });
        _super.prototype._hideTriggersCallback.call(this, dropDownContent);
    };
    /**
     * @desc onSlideChangeEnd callback sets active slide
     * @param {Slider} slider - slider object
     * @param {Boolean} isInitRun
     * @param {Boolean} isShowTriggerClicked - true if "show" trigger clicked
     * @private
     * @override
     */
    BSSSwiperTabsAnimations.prototype._setActiveSlide = function (slider, isInitRun, isShowTriggerClicked) {
        logger.info('SwiperTabsAnimations: ' +
            this._config.componentId +
            ' => function : _setActiveSlide | Params', slider, isInitRun, isShowTriggerClicked);
        if (typeof this._activeTriggerIndicator === 'undefined') {
            this._initAnimation();
        }
        this._changeClassSimulator(slider);
        this._changeIconDropdownMenu(slider);
        this._imageElements.removeClass('is-active');
        this._triggerSlides.removeClass('is-active');
        this._toolbox
            .$(this._triggerSlides[slider.activeIndex])
            .addClass('is-active');
        this._toolbox
            .$(this._imageElements[slider.activeIndex])
            .addClass('is-active');
        var activeSlide = this._toolbox.$(this._triggerSlides[slider.activeIndex]);
        var topPosition = 0;
        var leftPosition = 0;
        for (var i = 0, length_2 = slider.activeIndex; i < length_2; i += 1) {
            topPosition += this._toolbox.$(this._triggerSlides[i]).outerHeight();
            leftPosition += this._toolbox.$(this._triggerSlides[i]).outerWidth();
        }
        if (isInitRun) {
            this._activeTriggerIndicator.height(activeSlide.outerHeight());
            if (this._resolution.getCurrent() === 'xs') {
                this._activeTriggerIndicator.top = topPosition;
                this._activeTriggerIndicator.css({
                    left: 0,
                    top: topPosition,
                });
            }
            else {
                this._activeTriggerIndicator.width(activeSlide.outerWidth());
                this._activeTriggerIndicator.css({
                    left: this._toolbox.$(this._triggerSlides[0]).position().left,
                    top: 0,
                    height: '100%',
                });
            }
        }
        else {
            if (this._resolution.getCurrent() === 'xs') {
                this._activeTriggerIndicator.style = '';
                this._activeTriggerIndicator.left = 0;
            }
        }
        if (!isShowTriggerClicked) {
            this._scrollToTabBody();
        }
    };
    /**
     * @desc scrolls body to triggers nav element
     * @private
     */
    BSSSwiperTabsAnimations.prototype._scrollToTabBody = function () {
        logger.info('SwiperTabsAnimations: ' +
            this._config.componentId +
            ' => function : _scrollToTabBody');
        var scrollTop = this._isInPopup
            ? 0
            : this._entityTemplate.offset().top - this._getFixedOuterOffset();
        this._toolbox.$(this._globalHtmlBody).animate({ scrollTop: scrollTop }, 0.4);
    };
    /**
     * @desc scrolls body to swiper tab element
     * @private
     */
    BSSSwiperTabsAnimations.prototype._scrollToTab = function () {
        logger.info('SwiperTabsAnimations: ' +
            this._config.componentId +
            ' => function : _scrollToTab');
        var scrollTop = this.triggersWrapper.offset().top;
        this._toolbox.$(this._globalHtmlBody).animate({ scrollTop: scrollTop }, 0.4);
    };
    /**
     * @desc override method, adds extra method calls on init
     * @private
     * @override
     */
    BSSSwiperTabsAnimations.prototype._initSwiper = function () {
        logger.info('SwiperTabsAnimations: ' +
            this._config.componentId +
            ' => function : _initSwiper');
        _super.prototype._initSwiper.call(this);
        this._setActiveSlide(this._tabsContent, true);
    };
    /**
     * @desc triggers trigger tabs dropdown
     * @private
     * @override
     */
    BSSSwiperTabsAnimations.prototype._triggerDropdown = function () {
        logger.info('SwiperTabsAnimations: ' +
            this._config.componentId +
            ' => function : _triggerDropdown');
        if (this._resolution.getCurrent() !== 'xs') {
            return;
        }
        this._toolbox
            .$(this._triggerSlides[this._tabsContent.activeIndex])
            .removeClass('bss-swiper-tabs-nav_trigger-indicator');
        var dropDownContent = this._toolbox.$('#' + this._config.componentId + ' .bss-swiper-tabs-nav-wrapper');
        if (dropDownContent.hasClass('is-open')) {
            var animateTriggers = [];
            for (var i = this.animateTriggers.length - 1; i >= 0; i -= 1) {
                animateTriggers.push(this.animateTriggers[i]);
            }
            this._hideTriggersCallback(dropDownContent);
        }
        else {
            this._activeTriggerIndicator.height(0);
            this._activeTriggerIndicator.width = '';
            this._tabsTriggers.update();
            dropDownContent.css({ display: 'none' });
            dropDownContent.addClass('is-moved');
            dropDownContent.slideDown(this._config.slideDuration, this._showTriggersCallback.bind(this, dropDownContent));
        }
    };
    return BSSSwiperTabsAnimations;
}(BSSSwiperTabsComponent));
export default BSSSwiperTabsAnimations;
